import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-trash',
  templateUrl: './icon-trash.component.html'
})
export class IconTrashComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
